import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/crm/deals')({
  component: () => <PageStub title="Deals" description="Pipeline and deal management" />,
});
